import DataConnector from 'connect/DataConnector';
import {ManagedModelType} from 'models/ManagedModelDefinitions';

import {AssayRunValidation} from './ValidationConstants';

export interface RunValidationConnectorInputProps {
  assayRunIdForValidationFetch: string | null;
}
export interface RunValidationConnectorEnhancedProps {
  assayRunValidation: AssayRunValidation | null;
}
export class RunValidationConnector<P extends RunValidationConnectorInputProps> extends DataConnector<
  P,
  RunValidationConnectorEnhancedProps
> {
  enhanceProps(): RunValidationConnectorEnhancedProps {
    const validation = this.props.assayRunIdForValidationFetch
      ? this.getOrFetchOptional(
          ManagedModelType.ASSAY_RUN_VALIDATION,
          this.props.assayRunIdForValidationFetch
        )
      : null;
    return {assayRunValidation: validation};
  }
}
